import React from "react";

import { Box, Typography } from "@mui/material";
import { black } from "globals/design-system/colors";

type AirportInfoProps = {
  airportCode: string;
  airportName: string;
  transitStopType?: "origin" | "destination";
};

function AirportInfo(props: AirportInfoProps) {
  const { airportCode, airportName, transitStopType } = props;
  const isDestination = transitStopType === "destination";

  return (
    <Box
      display="flex"
      alignItems={isDestination ? "flex-end" : "flex-start"}
      flexDirection="column"
    >
      <Typography
        variant="body1"
        style={{ fontWeight: "bold", color: black }}
        {...(isDestination && { align: "right" })}
      >
        {airportCode}
      </Typography>

      <Typography
        variant="body2"
        style={{ color: black }}
        {...(isDestination && { align: "right" })}
      >
        {airportName}
      </Typography>
    </Box>
  );
}

export default AirportInfo;
